<template>
    <div>
        <SubLayout>
            <div v-if="$route.matched.length === 2" slot="center">
                <WebinarList
                    :value="events"
                    :hasDuration="true"
                    class="mb-4"
                    :listMode="false"
                    imageLeft
                    :vFairId="$route.params.id"
                />
            </div>

            <div v-if="$route.matched.length === 2" class="grid-bottom">
                <div>
                    <CompanyList
                        :data="featuredCompanies.slice(0, 5)"
                        :label="$t('components.navigation.navigation.companies')"
                        class="mb-3 w-100"
                        :resolveRoute="companyClickRoute"
                        :isLoading="companiesLoading"
                        forceList
                    />
                </div>

                <div>
                    <PostingModule
                        :data="postingData"
                        class="mb-3 w-100"
                        :resolveRoute="resolveRoute"
                        :isLoading="postingLoading()"
                        noToggles
                    />
                </div>
            </div>
        </SubLayout>

        <router-view></router-view>
    </div>
</template>

<script>
import WebinarList from './components/WebinarList';
import CompanyList from '../../../shared/CompanyList';
import PostingModule from '../../../shared/postingmodule/PostingModule';
import SubLayout from '../../../components/layouts/mainlayout/SubLayout';
import CompanyService from '~/services/CompanyService';
import { uuidFromURLParam } from '~/utils/urlUtils';

export default {
    name: 'Webinars',
    components: {
        SubLayout,
        PostingModule,
        CompanyList,
        WebinarList,
    },
    data() {
        return {
            companies: [],
            companiesLoading: true,
        };
    },
    computed: {
        vFairId() {
            return uuidFromURLParam(this.$route.params.id) || '';
        },
        events() {
            return this.fetchEvents();
        },
        postings() {
            return this.$interfaces.posting.get({
                reactive: true,
                vfair_id: this.vFairId,
                page_size: 5,
                page: 1,
            });
        },
        postingData() {
            if (!this.$route.query.pavilion_id) return this.postings.data || [];
            if (!this.postings.data || this.companiesLoading || !this.companies.length) return [];

            const companyIds = this.companies.map(company => company.organizationId);
            return this.postings.data.filter(posting =>
                companyIds.includes(parseInt(posting.companyId, 10))
            );
        },
        featuredCompanies() {
            return this.companies.map(org => {
                return {
                    id: org.organizationId,
                    logo: org.logo,
                    name: org.title,
                };
            });
        },
    },
    methods: {
        async fetchCompaniesData() {
            if (this.vFairId) {
                const pavilionId = this.$route.query.pavilion_id;
                const result = await CompanyService.getVFairCompanies(
                    this.vFairId,
                    typeof pavilionId === 'string' ? pavilionId : undefined
                );

                this.companiesLoading = false;
                this.companies = result.data.filter(c => c.status === 2);
            } else {
                return { loading: true };
            }
        },
        fetchEvents() {
            if (!this.vFairId) return [];

            const events = this.$interfaces.vfair.id(this.vFairId).events.get({
                reactive: true,
            }).data;

            if (!this.$route.query.pavilion_id) {
                this.addEventMessages(events);
                return events;
            }
            if (this.companiesLoading || !this.companies.length) return [];

            const companyIds = this.companies.map(company => company.organizationId);
            const filteredEvents = events.filter(event =>
                companyIds.includes(event.ownerOrganizationId)
            );
            this.addEventMessages(filteredEvents);
            return filteredEvents;
        },
        addEventMessages(events) {
            const vFairId = this.vFairId;
            if (!vFairId || !events.length || this.hasAddedMessages) return;

            const now = new Date().getTime();
            const withVFairId = events.reduce(
                (acc, ev) =>
                    new Date(ev.startTime).getTime() < now
                        ? acc
                        : [
                              ...acc,
                              {
                                  ...ev,
                                  vFairId,
                              },
                          ],
                []
            );

            const service = this.$interfaces.webinarMessageModule.getService();
            if (!service) return;
            service.addWebinars(withVFairId);
        },
        companyClickRoute(id) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/companies/', id);
            return url;
        },
        postingLoading() {
            return this.postings.loading;
        },
        resolveRoute(jobAdId) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/jobs/', jobAdId);
            return url;
        },
    },
    mounted() {
        this.fetchCompaniesData();
    },
};
</script>

<style lang="scss" scoped>
.grid-bottom {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: var(--grid-gap);
}
@media screen and (max-width: 1116px) {
    .grid-bottom {
        grid-template-columns: 1fr;
    }
}
</style>
